import { CreatePaymentUrlByPayeasyResopnseParam } from '../composables/order-entry'

const submitForm = (baseParams: CreatePaymentUrlByPayeasyResopnseParam) => {
  const form = document.createElement('form')
  form.action = baseParams.url
  form.method = 'POST'
  form.acceptCharset = 'Shift_JIS'

  const payload = new FormData()
  Object.keys(baseParams.form_data).forEach((key) => {
    payload.append(key, baseParams.form_data[key as keyof typeof baseParams.form_data] as string)
  })

  for (const [name, value] of payload) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value as string
    form.appendChild(input)
  }

  document.body.appendChild(form)
  form.submit()
}

export const useBJP = () => {
  return { submitForm }
}
